import { render, staticRenderFns } from "./KPIFormView.vue?vue&type=template&id=0c955885&scoped=true"
import script from "./KPIFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIFormView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIFormView.vue?vue&type=style&index=0&id=0c955885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c955885",
  null
  
)

export default component.exports